import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldValues } from 'react-hook-form';

import { SelectField } from 'common/forms/Field';
import { INotificationOffsetScale } from 'graphql/types';
import { TControllerProps } from 'common/types';

interface IProps {
    name: string;
    notificationOffset?: number;
}

export const NotificationScaleSelectField = <TFieldValues extends FieldValues>({
    notificationOffset,
    name,
    control,
}: IProps & TControllerProps<TFieldValues>) => {
    const [translate] = useTranslation();

    const notificationOffsetScaleOptions = useMemo(
        () => [
            {
                label: translate(
                    'certificateForm.notificationOffsetScaleOptions.days',
                    {
                        count: Number(notificationOffset) || 0,
                    }
                ),
                value: INotificationOffsetScale.Days,
            },
            {
                label: translate(
                    'certificateForm.notificationOffsetScaleOptions.weeks',
                    {
                        count: Number(notificationOffset) || 0,
                    }
                ),
                value: INotificationOffsetScale.Weeks,
            },
        ],
        [notificationOffset]
    );

    return (
        <SelectField
            control={control}
            label={translate('certificateForm.notificationOffsetScale')}
            name={name}
            options={notificationOffsetScaleOptions}
        />
    );
};
